import React from "react"

import soundDown from "@shared/assets/images/s-no_streamer.png"
import soundUp from "@shared/assets/images/s-uo_streamer.png"
import videoError from "@shared/assets/images/v-abnor_streamer.png"
import videoNormal from "@shared/assets/images/v-nor_streamer.png"

import { Message } from "../../hooks/useMessages"
import {broadcastCheckButtonTypes, CheckText} from "./CheckButton"

const StreamCheckEmoji = ({ message }: { message: Message }) => {
  if (!message.emoji) {
    return <>message.body</>
  }

  const key = message.emoji.replace(CheckText, '')

  const emojiFileName = StreamCheckEmojiFileName[key]

  return (
    <div style={{
      display: "inline-block",
      marginRight: 5,
    }}>
      <img src={emojiFileName} height={20} />
    </div>
  )
}

export default StreamCheckEmoji

const StreamCheckEmojiFileName = {
  [broadcastCheckButtonTypes.soundUp]: soundUp,
  [broadcastCheckButtonTypes.soundDown]: soundDown,
  [broadcastCheckButtonTypes.videoNormal]: videoNormal,
  [broadcastCheckButtonTypes.videoError]: videoError,
} as const
